__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/f9024a1/_next/";